import {
  ApolloClient,
  ApolloProvider,
  NormalizedCacheObject,
} from '@apollo/client';
import { Suspense } from 'react';
import { Navigate } from 'react-router-dom';

import { lazyRoute } from '@eluve/app-router-utils';

/*
 * Deferred for the same reason as the admin console: this table is reachable
 * from the app entry so its paths can be matched, but the review dashboard's
 * pages have no business in the login-screen bundle.
 */
const EluveAdminOrMlEngineerOnly = lazyRoute(
  'EluveAdminOrMlEngineerOnly',
  () => import('@eluve/smart-blocks'),
);
const AdminExportAppointmentsPage = lazyRoute(
  'AdminExportAppointmentsPage',
  () => import('./AdminExportAppointmentsPage'),
);
const DraftContent = lazyRoute(
  'DraftContent',
  () => import('./AppointmentArtifacts'),
);
const EhrDiffContent = lazyRoute(
  'EhrDiffContent',
  () => import('./AppointmentArtifacts'),
);
const EhrDraftContent = lazyRoute(
  'EhrDraftContent',
  () => import('./AppointmentArtifacts'),
);
const SummaryContent = lazyRoute(
  'SummaryContent',
  () => import('./AppointmentArtifacts'),
);
const SummaryDiffContent = lazyRoute(
  'SummaryDiffContent',
  () => import('./AppointmentArtifacts'),
);
const SummaryViewToggle = lazyRoute(
  'SummaryViewToggle',
  () => import('./AppointmentArtifacts'),
);
const AppointmentTranscripts = lazyRoute(
  'AppointmentTranscripts',
  () => import('./AppointmentTranscripts'),
);
const ReviewAppointmentLayout = lazyRoute(
  'ReviewAppointmentLayout',
  () => import('./ReviewAppointmentLayout'),
);
const ReviewAppointmentsPage = lazyRoute(
  'ReviewAppointmentsPage',
  () => import('./ReviewAppointmentsPage'),
);
const ReviewDashGuard = lazyRoute(
  'ReviewDashGuard',
  () => import('./ReviewDashGuard'),
);
const ReviewFeedbackPage = lazyRoute(
  'ReviewFeedbackPage',
  () => import('./ReviewFeedbackPage'),
);
const ReviewLayout = lazyRoute('ReviewLayout', () => import('./ReviewLayout'));
export const reviewAppointmentDetailsRoutes = [
  {
    index: true,
    element: <Navigate to="transcripts" replace />,
  },
  {
    path: 'transcripts',
    element: <AppointmentTranscripts />,
  },
  {
    path: 'summary',
    element: <SummaryContent />,
  },
  {
    path: 'golden-summary',
    element: <SummaryViewToggle />,
  },
  {
    path: 'draft',
    element: <DraftContent />,
  },
  {
    path: 'summary-diff',
    element: <SummaryDiffContent />,
  },
  {
    path: 'ehr-diff',
    element: <EhrDiffContent />,
  },
  {
    path: 'ehr-draft',
    element: <EhrDraftContent />,
  },
];

export const reviewAppointmentDetailsTabNav = [
  { name: 'Transcript', link: 'transcripts' },
  { name: 'Summary', link: 'summary' },
  { name: 'Golden Summary', link: 'golden-summary' },
  {
    name: 'Doctor Draft',
    link: 'draft',
  },
  {
    name: 'Summary Diff',
    link: 'summary-diff',
  },
  {
    name: 'EHR Diff',
    link: 'ehr-diff',
  },
  {
    name: 'EHR Draft',
    link: 'ehr-draft',
  },
];

export const createReviewRoutes = (
  path: string,
  client: ApolloClient<NormalizedCacheObject>,
) => {
  return [
    {
      path,
      element: (
        <ReviewDashGuard>
          <ApolloProvider client={client}>
            <Suspense>
              <ReviewLayout />
            </Suspense>
          </ApolloProvider>
        </ReviewDashGuard>
      ),
      children: [
        {
          index: true,
          element: <Navigate to="appointments" replace />,
        },
        {
          path: 'appointments',
          element: <ReviewAppointmentsPage />,
        },
        {
          path: 'admin/export',
          element: (
            <EluveAdminOrMlEngineerOnly>
              <AdminExportAppointmentsPage />
            </EluveAdminOrMlEngineerOnly>
          ),
        },
        {
          path: 'appointments/:tenantId/:appointmentId',
          element: <ReviewAppointmentLayout showTools />,
          children: reviewAppointmentDetailsRoutes,
        },
        {
          path: 'feedback',
          element: <ReviewFeedbackPage />,
        },
      ],
    },
  ];
};
